import { render, staticRenderFns } from "./new-double-good.vue?vue&type=template&id=2605bc86&scoped=true"
import script from "./new-double-good.vue?vue&type=script&lang=js"
export * from "./new-double-good.vue?vue&type=script&lang=js"
import style0 from "./new-double-good.vue?vue&type=style&index=0&id=2605bc86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605bc86",
  null
  
)

export default component.exports